import { options as n } from "preact";
var t,
    r,
    u,
    i,
    o = 0,
    c = [],
    f = [],
    e = n.__b,
    a = n.__r,
    v = n.diffed,
    l = n.__c,
    m = n.unmount;

function d(t, u) {
  n.__h && n.__h(r, t, o || u), o = 0;
  var i = r.__H || (r.__H = {
    __: [],
    __h: []
  });
  return t >= i.__.length && i.__.push({
    __V: f
  }), i.__[t];
}

function p(n) {
  return o = 1, y(z, n);
}

function y(n, u, i) {
  var o = d(t++, 2);

  if (o.t = n, !o.__c && (o.__ = [i ? i(u) : z(void 0, u), function (n) {
    var t = o.__N ? o.__N[0] : o.__[0],
        r = o.t(t, n);
    t !== r && (o.__N = [r, o.__[1]], o.__c.setState({}));
  }], o.__c = r, !r.u)) {
    r.u = !0;
    var c = r.shouldComponentUpdate;

    r.shouldComponentUpdate = function (n, t, r) {
      if (!o.__c.__H) return !0;

      var u = o.__c.__H.__.filter(function (n) {
        return n.__c;
      });

      if (u.every(function (n) {
        return !n.__N;
      })) return !c || c.call(this, n, t, r);
      var i = !1;
      return u.forEach(function (n) {
        if (n.__N) {
          var t = n.__[0];
          n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
        }
      }), !!i && (!c || c.call(this, n, t, r));
    };
  }

  return o.__N || o.__;
}

function h(u, i) {
  var o = d(t++, 3);
  !n.__s && w(o.__H, i) && (o.__ = u, o.i = i, r.__H.__h.push(o));
}

function s(u, i) {
  var o = d(t++, 4);
  !n.__s && w(o.__H, i) && (o.__ = u, o.i = i, r.__h.push(o));
}

function _(n) {
  return o = 5, F(function () {
    return {
      current: n
    };
  }, []);
}

function A(n, t, r) {
  o = 6, s(function () {
    return "function" == typeof n ? (n(t()), function () {
      return n(null);
    }) : n ? (n.current = t(), function () {
      return n.current = null;
    }) : void 0;
  }, null == r ? r : r.concat(n));
}

function F(n, r) {
  var u = d(t++, 7);
  return w(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}

function T(n, t) {
  return o = 8, F(function () {
    return n;
  }, t);
}

function q(n) {
  var u = r.context[n.__c],
      i = d(t++, 9);
  return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub(r)), u.props.value) : n.__;
}

function x(t, r) {
  n.useDebugValue && n.useDebugValue(r ? r(t) : t);
}

function V(n) {
  var u = d(t++, 10),
      i = p();
  return u.__ = n, r.componentDidCatch || (r.componentDidCatch = function (n) {
    u.__ && u.__(n), i[1](n);
  }), [i[0], function () {
    i[1](void 0);
  }];
}

function b() {
  for (var t; t = c.shift();) if (t.__P && t.__H) try {
    t.__H.__h.forEach(j), t.__H.__h.forEach(k), t.__H.__h = [];
  } catch (r) {
    t.__H.__h = [], n.__e(r, t.__v);
  }
}

n.__b = function (n) {
  r = null, e && e(n);
}, n.__r = function (n) {
  a && a(n), t = 0;
  var i = (r = n.__c).__H;
  i && (u === r ? (i.__h = [], r.__h = [], i.__.forEach(function (n) {
    n.__N && (n.__ = n.__N), n.__V = f, n.__N = n.i = void 0;
  })) : (i.__h.forEach(j), i.__h.forEach(k), i.__h = [])), u = r;
}, n.diffed = function (t) {
  v && v(t);
  var o = t.__c;
  o && o.__H && (o.__H.__h.length && (1 !== c.push(o) && i === n.requestAnimationFrame || ((i = n.requestAnimationFrame) || function (n) {
    var t,
        r = function () {
      clearTimeout(u), g && cancelAnimationFrame(t), setTimeout(n);
    },
        u = setTimeout(r, 100);

    g && (t = requestAnimationFrame(r));
  })(b)), o.__H.__.forEach(function (n) {
    n.i && (n.__H = n.i), n.__V !== f && (n.__ = n.__V), n.i = void 0, n.__V = f;
  })), u = r = null;
}, n.__c = function (t, r) {
  r.some(function (t) {
    try {
      t.__h.forEach(j), t.__h = t.__h.filter(function (n) {
        return !n.__ || k(n);
      });
    } catch (u) {
      r.some(function (n) {
        n.__h && (n.__h = []);
      }), r = [], n.__e(u, t.__v);
    }
  }), l && l(t, r);
}, n.unmount = function (t) {
  m && m(t);
  var r,
      u = t.__c;
  u && u.__H && (u.__H.__.forEach(function (n) {
    try {
      j(n);
    } catch (n) {
      r = n;
    }
  }), r && n.__e(r, u.__v));
};
var g = "function" == typeof requestAnimationFrame;

function j(n) {
  var t = r,
      u = n.__c;
  "function" == typeof u && (n.__c = void 0, u()), r = t;
}

function k(n) {
  var t = r;
  n.__c = n.__(), r = t;
}

function w(n, t) {
  return !n || n.length !== t.length || t.some(function (t, r) {
    return t !== n[r];
  });
}

function z(n, t) {
  return "function" == typeof t ? t(n) : t;
}

export { p as useState, y as useReducer, h as useEffect, s as useLayoutEffect, _ as useRef, A as useImperativeHandle, F as useMemo, T as useCallback, q as useContext, x as useDebugValue, V as useErrorBoundary };